import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import type { RootState } from "@/lib/redux/store";
import type {
  MiscellaneousMasterDataItem,
  ProtectionPackage,
} from "@/lib/types/miscellaneous";
import type { Vehicle } from "@/lib/types/vehicle";

export type MiscellaneousSelection = {
  addOns: MiscellaneousMasterDataItem[];
  quantities: Record<string, number>;
};

export type UserSelectedDetailsState = {
  vehicle: Vehicle | null;
  package: ProtectionPackage | null;
  miscellaneous: MiscellaneousSelection | null;
};

const initialState: UserSelectedDetailsState = {
  vehicle: null,
  package: null,
  miscellaneous: null,
};

const userSelectedDetailsSlice = createSlice({
  name: "userSelectedDetails",
  initialState,
  reducers: {
    setSelectedVehicleDetails(state, action: PayloadAction<Vehicle>) {
      state.vehicle = action.payload;
    },
    setSelectedPackageDetails(state, action: PayloadAction<ProtectionPackage>) {
      state.package = action.payload;
    },
    setSelectedMiscellaneousDetails(
      state,
      action: PayloadAction<MiscellaneousSelection>,
    ) {
      state.miscellaneous = action.payload;
    },
    clearUserSelectedDetails() {
      return initialState;
    },
  },
});

export const {
  setSelectedVehicleDetails,
  setSelectedPackageDetails,
  setSelectedMiscellaneousDetails,
  clearUserSelectedDetails,
} = userSelectedDetailsSlice.actions;

export default userSelectedDetailsSlice.reducer;

export const selectUserSelectedDetails = (state: RootState) =>
  state.userSelectedDetails;

export const selectUserSelectedVehicle = (state: RootState) =>
  state.userSelectedDetails.vehicle;

export const selectUserSelectedPackage = (state: RootState) =>
  state.userSelectedDetails.package;

export const selectUserSelectedMiscellaneous = (state: RootState) =>
  state.userSelectedDetails.miscellaneous;
